import { render } from "./FleetProfile.vue?vue&type=template&id=4efc33f5"
import script from "./FleetProfile.vue?vue&type=script&lang=js"
export * from "./FleetProfile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__